import wx from "weixin-js-sdk";
import HttpService from "@/service/HttpService";

export function initWechatShare(title, desc, link, imgUrl){
    // 微信分享链接支持
    // 微信开发者文档：https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#0
    imgUrl = imgUrl || "https://static.icode.org.cn/assets/ICODE_IX_ICODE.jpg";
    link = link || window.location.href;

    
    let userAgent = window.navigator.userAgent.toLowerCase(); 
    if (userAgent.indexOf('micromessenger') == -1){ // 非微信浏览器，无需注册
        return;
    }

    // console.log(title, desc, link, imgUrl);

    HttpService.getAxios("/wechat/getWeChatSign", {
        method: "post",
        data: {
            url: link.split("#")[0]
        }
    }).then(response => {
        const res = response.data;

        let _timestamp = res.data.timestamp;
        let _nonceStr = res.data.nonceStr;
        let _signature = res.data.signature;
        let _appId = res.appId;
        
        wx.config({
        debug: false, // 开启调试模式
        appId: _appId, // 必填，公众号的唯一标识
        timestamp: _timestamp, // 必填，生成签名的时间戳
        nonceStr: _nonceStr, // 必填，生成签名的随机串
        signature: _signature, // 必填，签名，见附录1
        jsApiList: [
            // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareQQ",
            "onMenuShareQZone"
        ]
        });
    });

    let wxOption = {
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
    };

    // wx.ready接口处理成功验证
    wx.ready(function() {
        // share to friends
        wx.updateAppMessageShareData(wxOption);
        wx.updateTimelineShareData(wxOption);
        wx.onMenuShareQQ(wxOption);
        wx.onMenuShareQZone(wxOption);
    });
}


// WEBPACK FOOTER //
// ./src/utils/wechat.js